// eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-unsafe-assignment
export default process.env.NODE_ENV === 'test' ? require('cross-fetch').fetch : fetch;
